import { useSiteSettings } from "./useSiteSettings";

/** Returns the current logo URL from settings, or empty string if not set. */
export function useSiteLogo(): string {
  const { getSetting } = useSiteSettings();
  return getSetting("site_logo", "");
}
